module.exports = __webpack_public_path__ + "img/news-image-review2.7a7a69f9.png";